import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import NavBranding from '../../molecules/NavBranding/NavBranding';
import NavLinkCollection from '../../molecules/NavLinkCollection/NavLinkCollection';
import NavLink from '../../atoms/NavLink/NavLink';
import ExpandableNavLink from '../../atoms/ExpandableNavLink/ExpandableNavLink';
import './Navbar.scss';

const Navbar = () => {
  const { isLoggedIn, user } = useSelector(state => state.auth);
  const location = useLocation();
  return (
    <div className="header-wrapper">
      <header>
        <div className="container d-flex align-items-center justify-content-between">
          <NavBranding alt="" text="Knowledge Cube" target="/" />
          <nav className="main-nav position-relative">
            <NavLinkCollection>
              <NavLink content="Buildings" target="/buildings" isActive={location.pathname === '/buildings'} />
              <NavLink content="Components" target="/instances/building-components" isActive={location.pathname === '/instances/building-components'} />
              <NavLink content="Elements" target="/instances/building-elements" isActive={location.pathname === '/instances/building-elements'} />
              <NavLink content="Products" target="/instances/building-products" isActive={location.pathname === '/instances/building-products'} />
              <NavLink content="Contexts" target="/instances/building-contexts" isActive={location.pathname === '/instances/building-contexts'} />
              <NavLink content="Characteristics" target="/instances/building-characteristics" isActive={location.pathname === '/instances/building-characteristics'} />
              <ExpandableNavLink content="Assets">
                <NavLink content="Locations" target="/countries" isActive={location.pathname === '/countries'} />
                <NavLink content="Dynasties" target="/dynasties" isActive={location.pathname === '/dynasties'} />
                <NavLink content="Building Types" target="/building-types" isActive={location.pathname === '/building-types'} />
                <NavLink content="Building Components" target="/building-components" isActive={location.pathname === '/building-components'} />
                <NavLink content="Building Elements" target="/building-elements" isActive={location.pathname === '/building-elements'} />
                <NavLink content="Products" target="/products" isActive={location.pathname === '/products'} />
                <NavLink content="Contexts" target="/contexts" isActive={location.pathname === '/contexts'} />
                <NavLink content="Characteristics" target="/characteristics" isActive={location.pathname === '/characteristics'} />
                <NavLink content="Data Types" target="/data-types" isActive={location.pathname === '/data-types'} />
                <NavLink content="Sources & Citations" target="/sources-citations" isActive={location.pathname === '/sources-citations'} />
              </ExpandableNavLink>
              <ExpandableNavLink content="More">
                <NavLink content="Scholars" target="/scholars" isActive={location.pathname === '/scholars'} />
                <NavLink content="Inventions" target="/inventions" isActive={location.pathname === '/inventions'} />
                <NavLink content="Museums" target="/museums" isActive={location.pathname === '/museums'} />
              </ExpandableNavLink>
              {!isLoggedIn && (
                <NavLink content="Login" target="/login" />
              )}
              {isLoggedIn && (
                <ExpandableNavLink content={`Hello, ${user.name}`}>
                  <NavLink content="Profile" target="/profile" />
                  <NavLink content="Manage Users" target="/users" />
                  <NavLink content="Logout" target="/logout" />
                </ExpandableNavLink>
              )}
            </NavLinkCollection>
          </nav>
        </div>
      </header>
    </div>
  );
};

export default Navbar;
